const openQuartierVenteList = [
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "ain-sebaa",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "les-hopitaux",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "liberte",
    },


    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "palmier",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "racine",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "gauthier",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "anfa",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "oulfa",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "sidi-maarouf",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "ain-chock",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "beausejour",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "belvedere",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "bourgogne-est",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "bourgogne-ouest",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "californie",
    },

    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "finance-city",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "val-fleurie",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "tamaris",
    },
    {
        slug: "rabat",
        type: "vente-appartements",
        quartier: "riyad",
    },
    {
        slug: "rabat",
        type: "vente-appartements",
        quartier: "l-ocean",
    },
    {
        slug: "rabat",
        type: "vente-appartements",
        quartier: "hassan-centre-ville",
    },
    {
        slug: "rabat",
        type: "vente-appartements",
        quartier: "agdal",
    },

    {
        slug: "rabat",
        type: "vente-villas",
        quartier: "agdal",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "roches-noires",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "marina",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "maarif",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "economique",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "haut-standing",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "moyen-standing",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "appartement-pas-cher",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "haut-standing-luxe",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "2eme-main",
    },
    {
        slug: "casablanca",
        type: "vente-appartements",
        quartier: "25-millions",
    },
    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "oulfa",
    },
    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "sidi-maarouf",
    },

    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "haut-standing",
    },
    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "moyen-standing",
    },

    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "haut-standing-luxe",
    },
    {
        slug: "casablanca",
        type: "vente-maisons",
        quartier: "2eme-main",
    },


    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "ain-diab",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "cil",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "anfa-superieur",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "ain-sebaa",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "anfa",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "oulfa",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "sidi-maarouf",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "ain-chock",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "beausejour",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "bourgogne-ouest",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "californie",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "finance-city",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "val-fleurie",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "tamaris",
    },

    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "maarif",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "haut-standing",
    },

    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "haut-standing-luxe",
    },
    {
        slug: "casablanca",
        type: "vente-villas",
        quartier: "2eme-main",
    },

    {
        slug: "marrakech",
        type: "vente-appartements",
        quartier: "ennakhil-palmeraie",
    },
    {
        slug: "marrakech",
        type: "vente-appartements",
        quartier: "gueliz",
    },
    {
        slug: "marrakech",
        type: "vente-appartements",
        quartier: "hivernage",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "route-d-ourika",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "ennakhil-palmeraie",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "amelkis",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "amelkis",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "route-de-fes",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "rahba-kedima",
    },
    {
        slug: "marrakech",
        type: "vente-villas",
        quartier: "masmoudi",
    }




];
export default openQuartierVenteList
